import React, { FC, useEffect } from "react";
import * as NavigationActions from '../../../actions/navigation';
import RestrictedLayout from "../../../components/layouts/RestrictedLayout";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { TrialSettingsBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { SettingsSubMenu, SettingsTrialSubMenu } from "../../../helpers/subMenuHelper";
import useDispatch, { useActionCreator } from "../../../hooks/useDispatch";
import useSelector from "../../../hooks/useSelector";
import SettingsCard from "../SettingsCard";

import './TrialSettingsPage.scss';

const TrialSettings: FC = () => {
    // Sidebar items
    const permissions = useSelector(state => state.user.userSummary?.permissions ?? []);
    const sideBarItems = SettingsSubMenu(permissions);
    
    // Breadcrumbs
    const breadcrumbs = TrialSettingsBreadcrumbs();

    // Menu items
    const menuItems = SettingsTrialSubMenu(permissions);

    const dispatch = useDispatch();
    const setDrawerItems = useActionCreator(NavigationActions.SetDrawerItems, dispatch);
    const setBreadcrumbs = useActionCreator(NavigationActions.SetBreadcrumbs, dispatch);

    useEffect(() => {
        setDrawerItems(sideBarItems);
        setBreadcrumbs(breadcrumbs);
    }, [setDrawerItems, setBreadcrumbs]);

    const renderTrialSettingsCards = () => {
        return menuItems?.filter(x => x.description)?.map((item, index) => (
            <SettingsCard 
                key={`item-${item.title}-${index}`}
                navItem={item}
            />
        ));
    }

    return (
        <RestrictedLayout
            permission={Dtos.Permission.TrialSettingsView}
        >
            <div className="settings-page">
                <div className="settings-container">
                    <h1 className="mb-4">Trial</h1>
                    <div className="settings-grid">
                        {renderTrialSettingsCards()}
                    </div>
                </div>
            </div>
        </RestrictedLayout>
    );
}

export default TrialSettings;